import { useCallback } from 'react';
import { Field } from 'react-final-form';
import { UniversalForm } from '@rainbow-modules/forms';
import Button from 'components/Button';
import {
    Container, Content, Footer, FieldsSection, StyledInput,
} from './styled';

interface FormValues extends Record<string, unknown> {
    friendlyName?: string;
}

interface Props {
    initialValues?: FormValues;
    onRequestClose?: () => void;
    onSubmit?: (values: FormValues) => Promise<void>;
}

const FORM_ID = 'edit-sip-user-form';

const EditSipUserForm = ({
    initialValues,
    onRequestClose = () => {},
    onSubmit,
}: Props) => {
    const handleSubmit = useCallback(
        async (values: Record<string, unknown>) => {
            if (onSubmit) await onSubmit(values as FormValues);
        },
        [onSubmit],
    );

    return (
        <Container>
            <Content>
                <UniversalForm id={FORM_ID} onSubmit={handleSubmit} initialValues={initialValues}>
                    <FieldsSection>
                        <Field
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            component={StyledInput}
                            name="friendlyName"
                            label="Friendly Name"
                            labelAlignment="left"
                            borderRadius="semi-square"
                            placeholder="e.g. Alice Smith"
                        />
                    </FieldsSection>
                </UniversalForm>
            </Content>
            <Footer>
                <Button
                    label="Cancel"
                    variant="outline-brand"
                    borderRadius="semi-square"
                    className="rainbow-m-right_medium"
                    onClick={onRequestClose}
                />
                <Button
                    label="Save"
                    variant="brand"
                    form={FORM_ID}
                    type="submit"
                    borderRadius="semi-square"
                />
            </Footer>
        </Container>
    );
};

export default EditSipUserForm;
